import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@/redux/store";

interface SettingsState {
  locationEnabled: boolean;
  locationPermission: "granted" | "denied" | "prompt" | "unsupported" | null;
  autoScrollEnabled: boolean;
  /** Number of messages to load per conversation. null means load all. */
  messageHistoryLimit: number | null;
}

const storedLimit = localStorage.getItem("settings.messageHistoryLimit");
const initialState: SettingsState = {
  locationEnabled: localStorage.getItem("settings.locationEnabled") === "true",
  locationPermission: null,
  autoScrollEnabled: localStorage.getItem("settings.autoScrollEnabled") !== "false",
  messageHistoryLimit: storedLimit === "null" ? null : storedLimit ? Number(storedLimit) : 200,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setLocationEnabled(state, action: PayloadAction<boolean>) {
      state.locationEnabled = action.payload;
      localStorage.setItem("settings.locationEnabled", String(action.payload));
    },
    setLocationPermission(
      state,
      action: PayloadAction<SettingsState["locationPermission"]>
    ) {
      state.locationPermission = action.payload;
    },
    setAutoScrollEnabled(state, action: PayloadAction<boolean>) {
      state.autoScrollEnabled = action.payload;
      localStorage.setItem("settings.autoScrollEnabled", String(action.payload));
    },
    setMessageHistoryLimit(state, action: PayloadAction<number | null>) {
      state.messageHistoryLimit = action.payload;
      localStorage.setItem("settings.messageHistoryLimit", String(action.payload));
    },
  },
});

export const { setLocationEnabled, setLocationPermission, setAutoScrollEnabled, setMessageHistoryLimit } =
  settingsSlice.actions;

export const selectLocationEnabled = (state: RootState) =>
  state.settings.locationEnabled;
export const selectLocationPermission = (state: RootState) =>
  state.settings.locationPermission;
export const selectAutoScrollEnabled = (state: RootState) =>
  state.settings.autoScrollEnabled;
export const selectMessageHistoryLimit = (state: RootState) =>
  state.settings.messageHistoryLimit;

export default settingsSlice.reducer;
